/**
 * discoverCategories (web) — mirrors the RN helper. Backend tiles carry a
 * semantic `icon` token; the web Icon component uses Ionicons web components,
 * so the token map resolves to the same Ionicons names as RN. Bundled fallback
 * keeps the chips populated offline / on first load.
 */
import type { CatalogCategory } from '@wg/types';

/** Semantic icon token -> Ionicons name (web Icon renders Ionicons). */
export const DISCOVER_ICON_MAP: Record<string, string> = {
  restaurant: 'restaurant-outline',
  restaurants: 'restaurant-outline',
  attractions: 'camera-outline',
  attraction: 'camera-outline',
  experiences: 'sparkles-outline',
  experience: 'sparkles-outline',
  tours: 'walk-outline',
  tour: 'walk-outline',
  nightlife: 'moon-outline',
  outdoors: 'leaf-outline',
  outdoor: 'leaf-outline',
  beach: 'sunny-outline',
  shopping: 'bag-handle-outline',
  events: 'calendar-outline',
  transport: 'bus-outline',
  wellness: 'heart-outline',
  family: 'people-outline',
};

const FALLBACK_ICON = 'location-outline';

export function resolveDiscoverIcon(token?: string | null): string {
  if (!token) return FALLBACK_ICON;
  return DISCOVER_ICON_MAP[token] ?? FALLBACK_ICON;
}

export function categoryLabel(cat: CatalogCategory): string {
  return cat.label || cat.name || cat.key || '';
}

/** Offline/first-load fallback — parity with the previous hard-coded chips. */
export const BUNDLED_DISCOVER_CATEGORIES: CatalogCategory[] = [
  { id: 'restaurants', key: 'restaurants', name: 'Restaurants', label: 'Restaurants', icon: 'restaurant',  query: { category: 'restaurants' }, display_order: 1 },
  { id: 'attractions', key: 'attractions', name: 'Attractions', label: 'Attractions', icon: 'attractions', query: { category: 'attractions' }, display_order: 2 },
  { id: 'experiences', key: 'experiences', name: 'Experiences', label: 'Experiences', icon: 'experiences', query: { category: 'experiences' }, display_order: 3 },
  { id: 'tours',       key: 'tours',       name: 'Tours',       label: 'Tours',       icon: 'tours',       query: { category: 'tours' },       display_order: 4 },
  { id: 'nightlife',   key: 'nightlife',   name: 'Nightlife',   label: 'Nightlife',   icon: 'nightlife',   query: { category: 'nightlife' },   display_order: 5 },
  { id: 'outdoors',    key: 'outdoors',    name: 'Outdoors',    label: 'Outdoors',    icon: 'outdoors',    query: { category: 'outdoors' },    display_order: 6 },
];
